<div class="avatars-container">
  <app-owner-avatar *ngFor="let i of dummyIterator" [ownerFilter]="getOwnerFilter(i)"></app-owner-avatar>
  <app-owner-avatar *ngIf="isRemaining" [remaining]="remaining"></app-owner-avatar>
</div>
